
export default {
  name: 'PagesAboutExtentionsUsersBecause',
  data() {
    return {
      answers: [
        {
          id: 1,
          title: 'Нет никаких лент с непонятным алгоритмом.',
          description:
            'Вы видите только то, на что подписались. Платформа не будет вам «подсовывать» продвигаемые материалы.',
        },
        {
          id: 2,
          title: 'Нет рекламы.',
          description:
            'На платформе нет отвлекающих баннеров, которые мешают изучать материалы.',
        },
        {
          id: 3,
          title: 'Никаких ежемесячных платежей.',
          description: 'На платформе нет сбора платежей. Всё бесплатно.',
        },
      ],
    }
  },
}
